import api from './api';

export const getWarmupDomainRules = (page, params) => {
  return api.get('admin/WarmupDomainsRule', { params: { page: page, limit: 5, ...params } });
};

export const createWarmupDomainRule = (channelUid, position, percent) => {
  return api.post('admin/warmup-domain-rule', { channelUid, position, percent });
};

export const removeWarmupDomainRules = id => {
  return api.delete(`admin/warmup-domain-rule/${id}`);
};